import { render, staticRenderFns } from "./TeamBox.vue?vue&type=template&id=090fd2d0&"
import script from "./TeamBox.vue?vue&type=script&lang=js&"
export * from "./TeamBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports